// AssetSoundView.js
import $ from 'jquery';

import AssetBaseView from 'advanced-inputs/AssetBaseView';
import template from 'advanced-inputs/control_sound.ejs';

//=====================================================================
//
// An instance of this view represents a Sound Asset control.
//
// Brad Trebilcock, February 21, 2016
//
//=====================================================================
class AssetSoundView extends AssetBaseView  {

    initialize( opts ) {
        super.initialize( opts );
        this.template = template;
        return this;
    }


}

export default AssetSoundView;
